import { HostListener, Input, Output, EventEmitter } from '@angular/core';

import * as _moment from 'moment';

import { KeyboardCode } from '../../../shared/keyboard/keyboard-code';
import { VrInputField } from '../../../shared/vr-element-field/vr-input-field';

_moment.locale('pt-br');
const moment = _moment;

export abstract class VrDatepicker extends VrInputField {
  @Input() useNonWorkingDays = false;
  @Output() valueText$ = new EventEmitter<string>();

  isHiddenCalendar = true;
  datepickerHeight = 0;

  @Input() set value(v: any) {
    if (v !== this.innerValue) {
      if (typeof v === 'string') {
        const date = moment(v);
        if (date.isValid()) {
          v = date.toDate();
        }
      }

      this.innerValue = v;
      this.elementChange(v);
      this.onChange(v);
    }
  }

  private _valueText = '';
  set valueText(v: string) {
    this.valueText$.emit(v);
    this._valueText = v;
  }

  get valueText(): string {
    return this._valueText;
  }

  openCalendar(): void {
    this.isHiddenCalendar = !this.isHiddenCalendar;
  }

  hiddenCalendar(): void {
    this.isHiddenCalendar = true;
  }

  selectDate(date: any): void {
    this.value = moment(date, 'DD/MM/YYYY').toDate();
    this.valueText = date;
    this.hiddenCalendar();
  }

  @HostListener('focusout', ['$event'])
  onFocusout(focusout: any): void {
    const numberOfDays = focusout.target.value.replace(/\D+/g, '') as number;
    if (numberOfDays > 0 && numberOfDays < 1000) {
      const today = moment(new Date(), 'DD/MM/YYYY');
      const currentDate = today.add(numberOfDays, 'days');
      const valueText = currentDate.format('DD/MM/YYYY');
      focusout.target.value = valueText;
      this.valueText = valueText;
      const value = currentDate.toDate();
      this.value = value;
      this.onChange(value);
    } else {
      this.checkIsValidAndShowError();
    }
  }

  @HostListener('keyup', ['$event'])
  onKeyup(keyup: KeyboardEvent): void {
    const code = keyup.code;

    if (code === KeyboardCode.TAB || code === KeyboardCode.BACKSPACE) {
      keyup.preventDefault();
      return;
    }

    if (keyup.code === KeyboardCode.KEY_H) {
      this.setTodayValue();
      return;
    }

    const inputElement = keyup.target as HTMLInputElement;
    this.setValueWithMask(inputElement?.value);
  }

  private setTodayValue(): void {
    const today = moment();
    this.valueText = today.format('DD/MM/YYYY');
    this.value = today.toDate();
  }

  private setValueWithMask(value: string): void {
    const valueWithMask = this.applayMask(value);
    this.valueText = valueWithMask;
    this.value = moment(valueWithMask, 'DD/MM/YYYY').toDate();
  }

  private applayMask(value: string): string {
    value = value.replace(/\D+/g, '');

    const mask = '00/00/0000';
    const pad = mask.replace(/\D/g, '').replace(/0/g, '_');
    const valueMask = value + pad.substring(0, pad.length - value.length);

    return this.formatValue(valueMask, mask);
  }

  private formatValue(value: string, mask: string): string {
    let valueWithMask = '';
    for (let i = 0, valueMaskPos = 0; i < mask.length; i++) {
      if (isNaN(parseInt(mask.charAt(i), 10))) {
        valueWithMask += mask.charAt(i);
      } else {
        valueWithMask += value[valueMaskPos++];
      }
    }

    if (valueWithMask.indexOf('_') > -1) {
      valueWithMask = valueWithMask.substr(0, valueWithMask.indexOf('_'));
    }

    return valueWithMask;
  }

  private checkIsValidAndShowError(date: any = this.value): void {
    this.errorMessage = null;
    let isInvalid = false;
    if (!!date) {
      isInvalid = !this.isValid(date);
      if (isInvalid) {
        this.errorMessage = 'Data inválida';
      }
    }
    this.isError = isInvalid;
  }

  private isValid(date: any): boolean {
    if (date instanceof Date) {
      return true;
    }

    date = moment(date, 'DD/MM/YYYY');
    return date.isValid();
  }

  protected elementChange(v: any): void {
    if (!!v && !!!this._valueText) {
      this.valueText = moment(v, 'DD/MM/YYYY').format('DD/MM/YYYY');
    }
    super.elementChange(v);
  }
}
